"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var Stores = require("../store/ServiceInApplication");
var reactstrap_1 = require("reactstrap");
var sweetalert2_1 = require("sweetalert2");
var ModalServiceInApplicationComponent = /** @class */ (function (_super) {
    __extends(ModalServiceInApplicationComponent, _super);
    function ModalServiceInApplicationComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.setTdStatus = function (item) {
            if (item.link_active_status == "unregister") {
                return React.createElement(reactstrap_1.Button, { color: "primary", "data-serid": item.service_id, onClick: function () { return _this.registerClick(item.service_id); } }, "Register");
            }
            else if (item.link_active_status == "pending") {
                return React.createElement("div", null,
                    React.createElement(reactstrap_1.Button, { color: "primary", "data-serid": item.service_id, onClick: function () { return _this.acceptClick(item.service_id); } }, "Accept"),
                    ' ',
                    React.createElement(reactstrap_1.Button, { color: "danger", "data-serid": item.service_id, onClick: function () { return _this.rejectClick(item.service_id); } }, "Reject"));
            }
            else if (item.link_active_status == "active") {
                return item.link_active_status;
            }
        };
        _this.state = {
            pageLoad: true,
            isOpen: false,
            isSubmitClick: false
        };
        _this.toggleModal = _this.toggleModal.bind(_this);
        _this.registerClick = _this.registerClick.bind(_this);
        _this.acceptClick = _this.acceptClick.bind(_this);
        _this.rejectClick = _this.rejectClick.bind(_this);
        return _this;
    }
    ModalServiceInApplicationComponent.prototype.toggleModal = function () {
        this.setState({
            isOpen: !this.state.isOpen
        });
        if (!this.state.isOpen) {
            this.props.afterCloseModal();
        }
    };
    ModalServiceInApplicationComponent.prototype.registerClick = function (id) {
        var _this = this;
        sweetalert2_1.default.fire({
            title: 'Are you sure to Register?',
            text: "",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then(function (result) {
            if (result.isConfirmed) {
                _this.props.requestFunction(_this.state.pageLoad, _this.props.appUUID, id, "POST");
                _this.setState({
                    isSubmitClick: true
                });
            }
            else {
            }
        });
    };
    ModalServiceInApplicationComponent.prototype.acceptClick = function (id) {
        var _this = this;
        sweetalert2_1.default.fire({
            title: 'Are you sure to Accept?',
            text: "",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then(function (result) {
            if (result.isConfirmed) {
                _this.props.requestFunction(_this.state.pageLoad, _this.props.appUUID, id, "PUT");
                _this.setState({
                    isSubmitClick: true
                });
            }
            else {
            }
        });
    };
    ModalServiceInApplicationComponent.prototype.rejectClick = function (id) {
        var _this = this;
        sweetalert2_1.default.fire({
            title: 'Are you sure to Reject?',
            text: "",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then(function (result) {
            if (result.isConfirmed) {
                _this.props.requestFunction(_this.state.pageLoad, _this.props.appUUID, id, "DELETE");
                _this.setState({
                    isSubmitClick: true
                });
            }
            else {
            }
        });
    };
    ModalServiceInApplicationComponent.prototype.render = function () {
        var _this = this;
        //console.log("isOpenModal - " + this.props.isOpenModal);
        //console.log("appUUID - " + this.props.appUUID);
        //console.log("appName - " + this.props.appName);
        if (this.props.isOpenModal) {
            this.toggleModal();
            this.props.requestFunction(this.state.pageLoad, this.props.appUUID, "", "GET");
            this.props.afterOpenModal();
        }
        if (this.props.isLoading) {
            console.log(this.props.response);
            if (this.props.isRegister && this.state.isSubmitClick) {
                console.log(this.props.response);
                console.log("message - " + this.props.message);
                this.setState({
                    isSubmitClick: false
                });
            }
        }
        return (React.createElement("div", null,
            React.createElement(reactstrap_1.Modal, { isOpen: this.state.isOpen, style: { maxWidth: "1200px" } },
                React.createElement(reactstrap_1.ModalHeader, { toggle: this.toggleModal },
                    "Service In Application ",
                    React.createElement("br", null),
                    " Application Name:",
                    ' ' + this.props.appName),
                React.createElement(reactstrap_1.ModalBody, null,
                    React.createElement("div", { style: { overflow: "auto", maxHeight: "calc(100vh - 270px)", minHeight: "200px" } },
                        React.createElement("table", { className: 'table table-bordered' },
                            React.createElement("thead", null,
                                React.createElement("tr", { style: { background: "rgba(9, 132, 227, 1)", color: "#fff", fontSize: '10pt' } },
                                    React.createElement("td", null, "Service ID"),
                                    React.createElement("td", null, "Service Name"),
                                    React.createElement("td", null, "Created By"),
                                    React.createElement("td", null, "Created On"),
                                    React.createElement("td", null, "Status"))),
                            React.createElement("tbody", null,
                                (this.props.isLoading && this.props.response.result_list != undefined) && this.props.response.result_list.map(function (item) {
                                    return React.createElement("tr", { key: item.service_id, className: 'table-tbody table-tr-' + item.link_active_status },
                                        React.createElement("td", null, item.service_id),
                                        React.createElement("td", null, item.service_name),
                                        React.createElement("td", null, item.created_by),
                                        React.createElement("td", null, item.created_on),
                                        React.createElement("td", null, _this.setTdStatus(item)));
                                }),
                                !this.props.isLoading ? React.createElement("tr", null,
                                    React.createElement("td", { colSpan: 8, style: { background: "rgba(209, 250, 221, 1)", color: "black", fontSize: '10pt', textAlign: "center" } }, "Loading...")) : '')))),
                React.createElement(reactstrap_1.ModalFooter, null,
                    React.createElement(reactstrap_1.Button, { color: "secondary", onClick: this.toggleModal }, "Close")))));
    };
    return ModalServiceInApplicationComponent;
}(React.PureComponent));
exports.default = react_redux_1.connect(function (state) { return state.serviceInApplication; }, Stores.actionCreators)(ModalServiceInApplicationComponent);
//# sourceMappingURL=ModalServiceInApplicationComponent.js.map